import script from "./AddressPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressPage.vue?vue&type=script&setup=true&lang=js"

import "./AddressPage.vue?vue&type=style&index=0&id=6973f069&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6973f069"]])

export default __exports__